module.exports = __webpack_public_path__ + "static/img/4.821bcde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/4.jpg
// module id = 2/00
// module chunks = 1